import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M11.051 4.898H7.294c-1.503 0-2.255 0-2.829.292a2.7 2.7 0 0 0-1.172 1.173C3 6.937 3 7.689 3 9.192v7.514c0 1.503 0 2.255.293 2.829.257.505.667.915 1.172 1.172C5.04 21 5.791 21 7.294 21h7.514c1.503 0 2.255 0 2.829-.293a2.7 2.7 0 0 0 1.173-1.172c.292-.574.292-1.326.292-2.829v-3.757M8.367 15.633h1.498c.438 0 .657 0 .863-.05q.275-.066.517-.214c.18-.11.335-.265.645-.575l8.554-8.554a1.898 1.898 0 1 0-2.683-2.684L9.206 12.11c-.31.31-.464.465-.575.645a1.8 1.8 0 0 0-.214.517c-.05.206-.05.425-.05.863z"
    }, null, -1)
  ])))
}
export default { render: render }